"use strict";
export var UnitagEventName = /* @__PURE__ */ ((UnitagEventName2) => {
  UnitagEventName2["UnitagBannerActionTaken"] = "Unitag Banner Action Taken";
  UnitagEventName2["UnitagOnboardingActionTaken"] = "Unitag Onboarding Action Taken";
  UnitagEventName2["UnitagClaimAvailabilityDisplayed"] = "Unitag Claim Availability Displayed";
  UnitagEventName2["UnitagClaimed"] = "Unitag Claimed";
  UnitagEventName2["UnitagMetadataUpdated"] = "Unitag Metadata Updated";
  UnitagEventName2["UnitagChanged"] = "Unitag Changed";
  UnitagEventName2["UnitagRemoved"] = "Unitag Removed";
  return UnitagEventName2;
})(UnitagEventName || {});
export var FiatOffRampEventName = /* @__PURE__ */ ((FiatOffRampEventName2) => {
  FiatOffRampEventName2["FORBuySellToggled"] = "Fiat OnRamp Buy Sell Toggled";
  FiatOffRampEventName2["FiatOffRampAmountEntered"] = "Fiat OffRamp Amount Entered";
  FiatOffRampEventName2["FiatOffRampTokenSelected"] = "Fiat OffRamp Token Selected";
  FiatOffRampEventName2["FiatOffRampUnsupportedTokenBack"] = "Fiat OffRamp Unsupported Token Modal Back Button Pressed";
  FiatOffRampEventName2["FiatOffRampUnsupportedTokenSwap"] = "Fiat OffRamp Unsupported Token Modal Swap Button Pressed";
  FiatOffRampEventName2["FiatOffRampWidgetOpened"] = "Fiat OffRamp Widget Opened";
  FiatOffRampEventName2["FiatOffRampWidgetCompleted"] = "Fiat OffRamp Widget Completed";
  FiatOffRampEventName2["FiatOffRampFundsSent"] = "Fiat OffRamp Funds Sent";
  return FiatOffRampEventName2;
})(FiatOffRampEventName || {});
export var FiatOnRampEventName = /* @__PURE__ */ ((FiatOnRampEventName2) => {
  FiatOnRampEventName2["FiatOnRampAmountEntered"] = "Fiat OnRamp Amount Entered";
  FiatOnRampEventName2["FiatOnRampTransactionUpdated"] = "Fiat OnRamp Transaction Updated";
  FiatOnRampEventName2["FiatOnRampTokenSelected"] = "Fiat OnRamp Token Selected";
  FiatOnRampEventName2["FiatOnRampWidgetOpened"] = "Fiat OnRamp Widget Opened";
  return FiatOnRampEventName2;
})(FiatOnRampEventName || {});
export var InstitutionTransferEventName = /* @__PURE__ */ ((InstitutionTransferEventName2) => {
  InstitutionTransferEventName2["InstitutionTransferTransactionUpdated"] = "Institution Transfer Transaction Updated";
  InstitutionTransferEventName2["InstitutionTransferWidgetOpened"] = "Institution Transfer Widget Opened";
  return InstitutionTransferEventName2;
})(InstitutionTransferEventName || {});
